<div class="container d-flex vh-100 vw-100">
    <div class="card mx-auto my-auto">
        <div class="card-header">
            <img src="assets/logo.png" alt="logo" class="img-fluid">
        </div>
        <div class="card-body">
            <form (ngSubmit)="login()">
                <div class="mb-2">
                    <label for="username">{{ "email" | translate }}</label>
                    <input class="form-control" type="text" id="email" name="email" [(ngModel)]="credentials.email" required>
                </div>
                <div class="mb-2">
                    <label for="password">{{ "password" | translate }}</label>
                    <input class="form-control" type="password" id="password" name="password" [(ngModel)]="credentials.password" required>
                </div>
                <div class="mb-2">
                    <span class="text-danger" *ngIf="errorMessage">
                        {{errorMessage}}
                    </span>
                </div>
                <button type="submit" class="btn btn-primary">{{ "login" | translate }}</button>
            </form>
        </div>
    </div>
</div>